// Store
import { axiosInstance } from 'store/api/index'

export const getUnreadSignalsAPI = async () => {
  const response = await axiosInstance.get('/signals/unread')
  return response.data
}
